import { HttpClient } from '@angular/common/http';
import { BillingAddress } from './../../../new-service/interfaces/VehicleStorage';
import { Injectable } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import * as moment from 'moment';
import { ActiveRoutesDetail, Fees, OrderPayload, Product } from 'src/app/pages/active-routes/components/active-routes-detail/interfaces/ActiveRoutesDetail.interface';
import { catchError, from, map, Observable, switchMap } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { environment } from 'src/environments/environment';
import { FunnelCustomField } from 'src/app/shared/custom-fields-manager/custom-fields-manager.component';

export const FORM_KEYS = {
  AddressData: 'AddressData',
  OriginAddress: 'OriginAddress',
  DestinationAddress: 'DestinationAddress',
  Address: 'Address',
  Lat: 'Lat',
  Lng: 'Lng',
  ZoneId: "ZoneId",

  DayContactData: 'DayContactData',
  StartDate: 'StartDate',
  EndDate: 'EndDate',
  OriginContact: 'OriginContact',
  DestinationContact: 'DestinationContact',
  Name: 'Name',
  LastName: 'LastName',
  PhoneNumber: 'PhoneNumber',
  Email: 'Email',
  IsContactParticular: 'IsContactParticular',
  Details: 'Details',
  Comments: 'Comments',

  ProductData: "ProductData",
  TaxPercentage: "TaxPercentage",
  TotalOrderAmount: "TotalOrderAmount",
  TotalOrderTaxAmount: "TotalOrderTaxAmount",
  Products: "Products",
  Fees: "Fees",
  BillingAddress: "BillingAddress",
  CustomFields: "CustomFields",
  Pdf: 'Pdf',
  Tags: 'Tags'
};

export interface SaveHashes {
  OldOrderHash: string;
  NewOrderHash: string,
}


@Injectable({
  providedIn: 'root'
})
export class EditServiceService {

  private initialAddressValues: any;

  url = environment.identity_url;
  product_url = environment.products_url

  constructor(private fb: FormBuilder, private http: HttpClient, private authService: AuthService) { }

  // getAuthHeaders(): Observable<{ Authorization: string; }> {
  //   return from(this.authService.getAccessToken()).pipe(
  //     map((token) => ({ Authorization: 'Bearer ' + token })),
  //     catchError((error) => {
  //       console.error('Error fetching token', error);
  //       throw error;
  //     })
  //   );
  // }

  simulationEdit(ServiceDetailsToSend: OrderPayload, ProductKey: string) {

    return this.http.patch<OrderPayload>(`${this.product_url}/business/products/${ProductKey}`,
      ServiceDetailsToSend)
    // return this.getAuthHeaders().pipe(
    //   switchMap((headers) =>
    //     this.http.patch<OrderPayload>(`${this.product_url}/business/products/${ProductKey}`,
    //       ServiceDetailsToSend,
    //       { headers })
    //   )
    // );
  }

  saveEdit(OldHash: string | undefined, NewHash: string | undefined) {
    if (!OldHash || !NewHash) return;
    let saveHashes: SaveHashes = {
      OldOrderHash: OldHash,
      NewOrderHash: NewHash
    }
    return this.http.put<SaveHashes>(`${this.product_url}/business/order`,
      saveHashes
    )

    // return this.getAuthHeaders().pipe(
    //   switchMap((headers) =>
    //     this.http.put<SaveHashes>(`${this.product_url}/business/order`,
    //       saveHashes,
    //       { headers })
    //   )
    // );
  }











  // EDIT FORM 

  createServiceForm(ServiceDetails?: ActiveRoutesDetail): FormGroup {
    return new FormGroup({
      [FORM_KEYS.AddressData]: this.createAddressDataGroup(ServiceDetails),
      [FORM_KEYS.DayContactData]: this.createDayContactDataGroup(ServiceDetails),
      [FORM_KEYS.ProductData]: this.createProductDataGroup(ServiceDetails),
    });
  }

  createAddressDataGroup(ServiceDetails?: ActiveRoutesDetail): FormGroup {
    // AddressData
    const form = new FormGroup({
      [FORM_KEYS.OriginAddress]: this.createAddressGroup(
        ServiceDetails?.OriginAddress,
        ServiceDetails?.OriginLatitude,
        ServiceDetails?.OriginLongitude,
        ServiceDetails?.StartZoneId!
      ),
      [FORM_KEYS.DestinationAddress]: this.createAddressGroup(
        ServiceDetails?.DestinationAddress,
        ServiceDetails?.DestinationLatitude,
        ServiceDetails?.DestinationLongitude,
        ServiceDetails?.EndZoneId!
      ),
    });

    this.updateInitialAddresValues(form)
    return form;
  }

  updateInitialAddresValues(form: FormGroup) {
    this.initialAddressValues = JSON.parse(JSON.stringify(form.getRawValue()));
  }

  hasAddressDataChanged(form: FormGroup): boolean {
    const currentValues = form.getRawValue();
    return JSON.stringify(this.normalize(currentValues)) !== JSON.stringify(this.normalize(this.initialAddressValues));

  }

  normalize(value: FormGroup): any {
    return JSON.parse(JSON.stringify(value));
  }

  createAddressGroup(address = '', lat = 0, lng = 0, zoneId: string): FormGroup {
    // OriginAddress
    // DestinationAddress
    return new FormGroup({
      [FORM_KEYS.Address]: new FormControl(address, Validators.required),
      [FORM_KEYS.Lat]: new FormControl(lat, Validators.required),
      [FORM_KEYS.Lng]: new FormControl(lng, Validators.required),
      [FORM_KEYS.ZoneId]: new FormControl(zoneId)
    });
  }

  createDayContactDataGroup(ServiceDetails?: ActiveRoutesDetail): FormGroup {
    // DayContactData
    return new FormGroup({
      [FORM_KEYS.StartDate]: new FormControl(ServiceDetails?.StartDate, [Validators.required, this.dateTimeHasHourValidator()]),
      [FORM_KEYS.EndDate]: new FormControl(ServiceDetails?.EndDate, [Validators.required, this.dateTimeHasHourValidator()]),
      [FORM_KEYS.Comments]: new FormControl(ServiceDetails?.Comments ?? ''),
      [FORM_KEYS.BillingAddress]: new FormControl(ServiceDetails?.BillingAddress ?? '', []),
      [FORM_KEYS.OriginContact]: this.createContactGroup({
        name: ServiceDetails?.OriginContactName,
        lastName: '',
        phone: ServiceDetails?.OriginContactPhoneNumber,
        email: ServiceDetails?.OriginContactEmail,
        isExternal: ServiceDetails?.IsOriginContactExternal,
        details: ServiceDetails?.DestinationAddressDetails,
      }),
      [FORM_KEYS.DestinationContact]: this.createContactGroup({
        name: ServiceDetails?.DestinationContactName,
        lastName: '',
        phone: ServiceDetails?.DestinationContactPhoneNumber,
        email: ServiceDetails?.DestinationContactEmail,
        isExternal: ServiceDetails?.IsDestinationContactExternal,
        details: ServiceDetails?.DestinationAddressDetails,
      }),
      [FORM_KEYS.Pdf]: new FormControl(ServiceDetails?.Pdfs ?? []),
      [FORM_KEYS.Tags]: new FormControl(ServiceDetails?.Tags ?? [])
    });
  }

  createContactGroup(data: {
    name?: string;
    lastName?: string;
    phone?: string;
    email?: string;
    isExternal?: boolean;
    details?: string;
  }): FormGroup {
    return new FormGroup({
      [FORM_KEYS.Name]: new FormControl(data?.name ?? '', Validators.required),
      [FORM_KEYS.LastName]: new FormControl(data?.lastName ?? ''),
      [FORM_KEYS.PhoneNumber]: new FormControl(data?.phone ?? '', Validators.required),
      [FORM_KEYS.Email]: new FormControl(data?.email ?? ''),
      [FORM_KEYS.IsContactParticular]: new FormControl(data?.isExternal ?? false, Validators.required),
      [FORM_KEYS.Details]: new FormControl(data?.details ?? ''),

    });
  }

  createProductDataGroup(ServiceDetails?: ActiveRoutesDetail): FormGroup {
    // ProductData    
    return new FormGroup({
      [FORM_KEYS.TaxPercentage]: new FormControl(ServiceDetails?.FinancialInformation?.TaxPercentage ?? '', Validators.required),
      [FORM_KEYS.TotalOrderAmount]: new FormControl(ServiceDetails?.FinancialInformation?.TotalOrderAmount ?? '', Validators.required),
      [FORM_KEYS.TotalOrderTaxAmount]: new FormControl(ServiceDetails?.FinancialInformation?.TotalOrderTaxAmount ?? '', Validators.required),
      [FORM_KEYS.Products]: this.fb.array(
        (ServiceDetails?.FinancialInformation?.Products || []).map((p: Product) => this.createProductGroup(p))
      ),
      [FORM_KEYS.Fees]: this.fb.array(
        (ServiceDetails?.FinancialInformation?.Fees || []).map((p: Fees) => this.createFeeGroup(p))
      ),
    });
  }

  updateProductDataGroup(ServiceDetails?: ActiveRoutesDetail, TotalOrderAmount?: number, TotalOrderTaxAmount?: number, products?: Product[], fees?: Fees[]): FormGroup {
    // ProductData    
    return new FormGroup({
      [FORM_KEYS.TaxPercentage]: new FormControl(ServiceDetails?.FinancialInformation?.TaxPercentage ?? '', Validators.required),
      [FORM_KEYS.TotalOrderAmount]: new FormControl(TotalOrderAmount ?? '', Validators.required),
      [FORM_KEYS.TotalOrderTaxAmount]: new FormControl(TotalOrderTaxAmount ?? '', Validators.required),
      [FORM_KEYS.Products]: this.fb.array(
        (products || []).map((p: Product) => this.createProductGroup(p))
      ),
      [FORM_KEYS.Fees]: this.fb.array(
        (fees || []).map((p: Fees) => this.createFeeGroup(p))
      ),
    });
  }

  createProductGroup(product?: Product): FormGroup {
    return new FormGroup({
      ProductId: new FormControl(product?.ProductId ?? ''),
      ProductType: new FormControl(product?.ProductType ?? null, Validators.required),
      ProductKey: new FormControl(product?.ProductKey ?? '', Validators.required),
      Amount: new FormControl<number>(product?.Amount ?? 0, Validators.required),
      HasTaxes: new FormControl(product?.HasTaxes ?? false),
      TaxPercentage: new FormControl(product?.TaxPercentage ?? 0),
    });
  }

  createFeeGroup(fee?: Fees): FormGroup {
    return new FormGroup({
      Amount: new FormControl<number>(fee?.Amount ?? 0, Validators.required),
      HasTaxes: new FormControl(fee?.HasTaxes ?? false, Validators.required),
      FeeKey: new FormControl(fee?.FeeKey ?? ''),
      ProductKey: new FormControl(fee?.ProductKey ?? ''),
    });
  }





  private dateTimeHasHourValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      const dateWithTime = moment(value, 'DD-MM-YYYY HH:mm', true);

      if (!dateWithTime.isValid() || dateWithTime.format('HH:mm') === '00:00') {
        return { missingHour: true };
      }

      return null;
    };
  }

  getServiceDetailsByForm(ServiceForm: FormGroup, details: ActiveRoutesDetail) {
    return {
      BillingAddress: ServiceForm.get([FORM_KEYS.DayContactData, FORM_KEYS.BillingAddress])?.value,
      Comments: ServiceForm.get([FORM_KEYS.DayContactData, FORM_KEYS.Comments])?.value,

      OriginAddress: ServiceForm.get([FORM_KEYS.AddressData, FORM_KEYS.OriginAddress, FORM_KEYS.Address])?.value,
      OriginAddressDetails: ServiceForm.get([FORM_KEYS.DayContactData, FORM_KEYS.OriginContact, FORM_KEYS.Details])?.value,
      OriginContactEmail: ServiceForm.get([FORM_KEYS.DayContactData, FORM_KEYS.OriginContact, FORM_KEYS.Email])?.value,
      OriginContactName: ServiceForm.get([FORM_KEYS.DayContactData, FORM_KEYS.OriginContact, FORM_KEYS.Name])?.value,
      OriginContactPhoneNumber: ServiceForm.get([FORM_KEYS.DayContactData, FORM_KEYS.OriginContact, FORM_KEYS.PhoneNumber])?.value,
      OriginLatitude: ServiceForm.get([FORM_KEYS.AddressData, FORM_KEYS.OriginAddress, FORM_KEYS.Lat])?.value,
      OriginLongitude: ServiceForm.get([FORM_KEYS.AddressData, FORM_KEYS.OriginAddress, FORM_KEYS.Lng])?.value,
      IsOriginContactExternal: ServiceForm.get([FORM_KEYS.DayContactData, FORM_KEYS.OriginContact, FORM_KEYS.IsContactParticular])?.value,

      DestinationAddress: ServiceForm.get([FORM_KEYS.AddressData, FORM_KEYS.DestinationAddress, FORM_KEYS.Address])?.value,
      DestinationAddressDetails: ServiceForm.get([FORM_KEYS.DayContactData, FORM_KEYS.DestinationContact, FORM_KEYS.Details])?.value,
      DestinationContactEmail: ServiceForm.get([FORM_KEYS.DayContactData, FORM_KEYS.DestinationContact, FORM_KEYS.Email])?.value,
      DestinationContactName: ServiceForm.get([FORM_KEYS.DayContactData, FORM_KEYS.DestinationContact, FORM_KEYS.Name])?.value,
      DestinationContactPhoneNumber: ServiceForm.get([FORM_KEYS.DayContactData, FORM_KEYS.DestinationContact, FORM_KEYS.PhoneNumber])?.value,
      DestinationLatitude: ServiceForm.get([FORM_KEYS.AddressData, FORM_KEYS.DestinationAddress, FORM_KEYS.Lat])?.value,
      DestinationLongitude: ServiceForm.get([FORM_KEYS.AddressData, FORM_KEYS.DestinationAddress, FORM_KEYS.Lng])?.value,
      IsDestinationContactExternal: ServiceForm.get([FORM_KEYS.DayContactData, FORM_KEYS.DestinationContact, FORM_KEYS.IsContactParticular])?.value,

      EndDate: ServiceForm.get([FORM_KEYS.DayContactData, FORM_KEYS.EndDate])?.value,
      StartDate: ServiceForm.get([FORM_KEYS.DayContactData, FORM_KEYS.StartDate])?.value,

      EndZoneId: ServiceForm.get([FORM_KEYS.AddressData, FORM_KEYS.DestinationAddress, FORM_KEYS.ZoneId])?.value,
      StartZoneId: ServiceForm.get([FORM_KEYS.AddressData, FORM_KEYS.OriginAddress, FORM_KEYS.ZoneId])?.value,

      FinancialInformation: {
        Products: ServiceForm.get([FORM_KEYS.ProductData, FORM_KEYS.Products])?.value,
        Fees: ServiceForm.get([FORM_KEYS.ProductData, FORM_KEYS.Fees])?.value,
      },

      // OrderStatus: 1,

      Pdfs: ServiceForm.get([FORM_KEYS.DayContactData, FORM_KEYS.Pdf])?.value,
      ProductTypes: this.updateProductTypeByProduct(ServiceForm.get([FORM_KEYS.ProductData, FORM_KEYS.Products])?.value),
      // ProductsDetails: {
      //   Distance: 1.37
      // },
      Tags: ServiceForm.get([FORM_KEYS.DayContactData, FORM_KEYS.Tags])?.value, // TODO: FALTA POR AÑADIR LOS TAGS 
      CustomFields: details.CustomFields

    }
  }



  private updateProductTypeByProduct(Products: Product[]): number[] {
    return Products
      .map(x => x.ProductType)
      .filter((x): x is number => typeof x === 'number');
  }




}



